import Vue from "vue";
import Vuex from "vuex";
import loadersModule from "./modules/loaders";
import authModule from "./modules/auth";
import errorHandlerModule from "./modules/errorHandler";
import userModule from "./modules/user";
import customerModule from "./modules/customer";
import anonymousModule from "./modules/anonymous";
import alertModule from "./modules/alert";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    authModule,
    loadersModule,
    errorHandlerModule,
    userModule,
    customerModule,
    anonymousModule,
    alertModule,
  },
});
